<template>
    <router-view v-slot="{Component}">
        <keep-alive>
            <component v-bind:is="Component"/>
        </keep-alive>
    </router-view>
</template>